import dayjs, { type Dayjs } from 'dayjs';

export const RANGE_PICKER_PRESETS = (t: (key: string) => string): { label: string; value: [Dayjs, Dayjs] }[] => [
    {
        label: t('last_7_days'),
        value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
        label: t('last_14_days'),
        value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
        label: t('last_30_days'),
        value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
        label: t('last_90_days'),
        value: [dayjs().add(-90, 'd'), dayjs()],
    },
];
